module.exports = __webpack_public_path__ + "media/applicants/device_signup_5-fr-54d81d15.webp";